window.appVars = {

    csrfToken: document.querySelector('[name=csrf-token]').content,

    apiUrl:'/api/',

};



